import CryptoJS from "crypto-js";

const secret_key = process.env.REACT_APP_SECRET_KEY_FOR_ID;

const key = CryptoJS.SHA256(secret_key); // 32-byte AES key

export const encryptString = (plainText: string | undefined): string => {
  if (!plainText) return "";
  const iv = CryptoJS.lib.WordArray.random(16);
  const encrypted = CryptoJS.AES.encrypt(plainText, key, { iv: iv });
  const mergedData = iv.clone().concat(encrypted.ciphertext);
  const mergedDataB64 = CryptoJS.enc.Base64.stringify(mergedData);
  return mergedDataB64;
};

export const decryptString = (base64Cipher?: string): string => {
  if (!base64Cipher) return "";
  try {
    const transit = CryptoJS.enc.Base64.parse(base64Cipher);

    if (transit.sigBytes < 16) throw new Error("cipher too short");
    const iv = CryptoJS.lib.WordArray.create(transit.words.slice(0, 4), 16);
    const ciphertext = CryptoJS.lib.WordArray.create(
      transit.words.slice(4),
      transit.sigBytes - 16,
    );

    const params = CryptoJS.lib.CipherParams.create({ ciphertext });
    const bytes = CryptoJS.AES.decrypt(params, key, {
      iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    return bytes.toString(CryptoJS.enc.Utf8);
  } catch (e) {
    console.error("Decrypt error:", e);
    return "";
  }
};